<template>
  <div class="page_directPayment">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="98px">
            <el-form-item label="打款编号" size="small">
              <el-input v-model="listQuery.busNum" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.ProjectId" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="费用名称" size="small">
              <el-input v-model="listQuery.descFees" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
          <div>
            <el-form-item label="收款账号名称" size="small" label-width="125px">
              <el-input v-model="listQuery.receiveComp" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="收款银行" size="small">
              <el-input v-model="listQuery.receiveBank" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="收款账号" size="small">
              <el-input v-model="listQuery.receiveAccount" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="打款账号名称" size="small" label-width="125px">
              <el-input v-model="listQuery.payComp" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="打款银行" size="small">
              <el-input v-model="listQuery.payCompOpenBank" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="打款账号" size="small">
              <el-input v-model="listQuery.payAccount" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </div>
          <div>
            <!-- <el-form-item label="时间类型" size="small" label-width="115px">
              <el-select v-model="listQuery.name" placeholder="" clearable filterable style="width:180px">
                <el-option value="打款时间"></el-option>
                <el-option value="申请时间"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="打款开始时间" size="small" label-width="125px">
              <el-date-picker v-model="listQuery.paymentTimeStart" type="date" value-format="yyyy-MM-dd" size="small" style="width:180px">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="打款结束时间" size="small">
              <el-date-picker v-model="listQuery.paymentTimeEnd" type="date" value-format="yyyy-MM-dd" size="small" style="width:180px">
              </el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="操作者" size="small">
              <el-select v-model="listQuery.username" placeholder="" clearable size="small" style="width: 180px;" value-key="Userid" filterable>
                <el-option v-for="(item,index) in customerList" :key="index" :label="item.Username" :value="item.Username"></el-option>
              </el-select>
            </el-form-item> -->
          </div>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>直接付款</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="changeTab">
          <el-tab-pane label="全部" name="0"></el-tab-pane>
          <el-tab-pane label="打款失败" name="1"></el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex" v-if="activeName=='0'">
          <el-button type="success" size="small" @click="addPayment">新增付款</el-button>
          <el-button type="primary" size="small">导出</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center" width="45" fixed="left">
          </el-table-column>
          <el-table-column prop="busNum" label="打款编号" min-width="170" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="directCaymType" label="交易类型" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.directCaymType == 1 ? '内部转账' : '外部转账'}}</template>
          </el-table-column>
          <el-table-column prop="name" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.payResult == '1' ? '打款成功' : row.payResult == '2' ? '打款失败' : row.payResult == '3' ? '待打款' : '打款中'}}</template>
          </el-table-column>
          <el-table-column prop="descFees" label="费用名称" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="name" label="服务公司" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column prop="projectName" label="服务客户项目" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="paymentAmount" label="打款金额" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="paymentTime" label="打款时间" min-width="160" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.paymentTime ? row.paymentTime.replace('T',' ') : '' }}</template>
          </el-table-column>
          <el-table-column prop="receiveComp" label="收款帐号名称" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="receiveAccount" label="收款帐号" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="receiveBank" label="开户银行" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="payComp" label="打款公司" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="payAccount" label="打款帐号" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="payCompOpenBank" label="打款银行" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="银行流水号" min-width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="descFees" label="费用说明" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="summary" label="付款说明" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="fundUse" label="款项用途" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="username" label="操作者" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="附件" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center" v-if="activeName!='待面试'" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="downReceipt(row)">下载回单</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="直接付款" :visible.sync="showAddPaymnt" width="800px" class="res_dialog enter_dialog">
      <el-form :model="payForm" :rules="payRules" ref="payForm" label-width="110px">
        <el-form-item>
          <el-radio-group v-model="payForm.DirectCaymType">
            <el-radio label="1">内部转账</el-radio>
            <el-radio label="2">外部付款</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="付款金额:" prop="PaymentAmount">
          <div class="payInput">
            <el-input v-model="payForm.PaymentAmount" size="small" style="width:300px" type="number">
              <i slot="prepend">￥</i>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item label="付款公司:" prop="PayComp">
          <el-select v-model="payForm.PayComp" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changePayComp">
            <el-option v-for="(item, index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付款银行帐号:" prop="PayAccount">
          <el-radio :label="bank.Account" v-for="bank in BankAccount" :key="bank.Account" style="margin-bottom: 10px;" v-model="payForm.PayAccount" @input="(val) => { inputChange(val, bank.OpeningBank,'PayCompOpenBank')}">开户行：{{ bank.OpeningBank }} 帐号：{{
          bank.Account
        }}</el-radio>
        </el-form-item>
        <el-form-item label="收款公司:" prop="ReceiveComp" v-if="payForm.DirectCaymType=='1'">
          <el-select v-model="payForm.ReceiveComp" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changeReceiveComp">
            <el-option v-for="(item, index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款银行帐号:" prop="PayAccount" v-if="payForm.DirectCaymType=='1'">
          <el-radio :label="bank.Account" v-for="bank in BankAccount2" :key="bank.Account" style="margin-bottom: 10px;" v-model="payForm.ReceiveAccount" @input="(val) => { inputChange(val, bank.OpeningBank,'ReceiveBank')}">开户行：{{ bank.OpeningBank }} 帐号：{{
          bank.Account
        }}</el-radio>
        </el-form-item>
        <el-form-item label="收款方户名" size="small" prop="ReceiveComp" v-if="payForm.DirectCaymType=='2'">
          <el-input v-model="payForm.ReceiveComp" size="small" clearable style="width:300px" v-if="payForm.DirectCaymType=='2'"></el-input>
        </el-form-item>
        <el-form-item label="收款方开户行" size="small" prop="ReceiveBank" v-if="payForm.DirectCaymType=='2'">
          <el-input v-model="payForm.ReceiveBank" size="small" clearable style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="收款银行帐号" size="small" prop="ReceiveAccount" v-if="payForm.DirectCaymType=='2'">
          <el-input v-model="payForm.ReceiveAccount" size="small" clearable style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="联行号" size="small" v-if="payForm.DirectCaymType=='2'">
          <div ref="chickBox1">
            <el-input v-model="payForm.CnapsCode" placeholder="支持开户行模糊搜索" size="small" style="width:300px" ref="CnapsCode" @input="changeCCD"></el-input>
            <el-button type="primary" size="small" style="margin-left:10px" @click="querySearchAsync($event)">模糊搜索</el-button>
            <div v-show="showAddressSelect" class="addressSelect">
              <div v-for="(item,index) in recommendList" :key="index" class="addressSelectItem cp" @click.stop="handleSelect(item)">
                <span>{{ item.cnapsCode }}</span>
                <span class="remake">{{item.fullName}}</span>
              </div>
              <div v-if="recommendList.length==0" class="empty">
                暂无匹配项
              </div>
            </div>
          </div>
          <div class="bankNameR" v-if="fullName && fullName != payForm.ReceiveBank">
            联行号支行：{{fullName}}
          </div>
        </el-form-item>
        <el-form-item label="款项用途" size="small" prop="FundUse">
          <el-input v-model="payForm.FundUse" size="small" clearable style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="费用说明" size="small" v-if="payForm.DirectCaymType=='1'">
          <el-input v-model="payForm.DescFees" size="small" clearable style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="是否需要核销" size="small" prop="WriteOffMark">
          <el-radio-group v-model="payForm.WriteOffMark">
            <el-radio label="1">需要</el-radio>
            <el-radio label="0">不需要</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="核销责任人" size="small" prop="WriteOffMark" v-if="payForm.DirectCaymType=='2' && payForm.WriteOffMark == '1'">
          <el-select v-model="listQuery.PersonRespons" placeholder="" clearable size="small" style="width: 300px;" value-key="Userid" filterable @change="changePR">
            <el-option v-for="(item,index) in customerList" :key="index" :label="item.Username" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务部门" size="small">
          <el-cascader v-model="SevrvceDeptName" size="small" :props="props" clearable filterable :options="departList" placeholder="请选择部门" @change="departChange" style="width:300px"></el-cascader>
        </el-form-item>
        <el-form-item label="服务项目" size="small">
          <el-select v-model="payForm.ProjectName" placeholder="" value-key="Projectid" size="small" style="width: 300px;" clearable filterable>
            <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付款说明" size="small">
          <el-input v-model="payForm.Summary" size="small" clearable style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="上传附件" size="small">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">上传附件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddPaymnt = false" size="small">取消</el-button>
        <el-button type="primary" size="small" :loading="isBtnLoading" @click="comfirmPay">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    index,
    number,
    replacer
  } from "mathjs";
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: [{
              property: "createTime",
              order: 0
            }]
          },
          id: "",
          directCaymType: '', //直付类型1为内2为外
          paymentAmount: '', //付款金额
          referenceNum: "",
          payAccount: "",
          busNum: "",
          payErrMsg: "",
          payComp: "",
          payCompOpenBank: "",
          receiveComp: "",
          receiveBank: "",
          receiveAccount: "",
          fundUse: "",
          descFees: "",
          writeOffMark: "",
          sevrvceDeptName: "",
          projectName: "",
          payResult: "",
          summary: "",
          fileName: "",
          fileUrl: "",
          personRespons: "",
          personResponsName: "",
          elecBillUrl: "",
          paymentTimeStart: '',
          paymentTimeEnd: '',
          // username: '', //操作者
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        showDropScreen: -1,
        activeName: '0',
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        proNameList: [], //项目列表
        multipleSelection: [],
        isBtnLoading: false,
        showAddPaymnt: false,
        showAddressSelect: false,
        recommendList: [],
        fullName: '',
        payForm: {
          Id: '',
          DirectCaymType: '1', //直付类型1为内2为外
          PaymentAmount: '', //付款金额
          PayAccount: '', //付款账号
          PayComp: '', //付款公司
          PayCompOpenBank: '', //开户行
          ReceiveComp: '', //收款公司名
          ReceiveBank: '', //收款开户行
          ReceiveAccount: '', //收款账号
          CnapsCode: '', //联行号
          FundUse: '', //款项用途
          DescFees: '', //费用说明
          WriteOffMark: '0', //是否核销标记,1为要核销，0为不用核销
          SevrvceDeptName: '', //服务部门
          ProjectName: '', //
          PayResult: '', //付款结果1.打款成功2.打款失败，3待打款,4.打款中
          Summary: '', //付款说明
          FileName: '', //文件名
          FileUrl: '', //文件名URL
          PersonRespons: '', //责任人ID
          PersonResponsName: '', //责任人
          userId: Cookies.get("userid-b"),
        },
        SevrvceDeptName: [],
        fileList: [],
        legList: [],
        BankAccount: [],
        BankAccount2: [],
        customerList: [], //人员列表
        departList: [], //部门列表
        props: {
          label: "strorganname",
          value: "strorganname",
          children: "children",
          checkStrictly: true,
        },
        payRules: {
          DirectCaymType: {
            required: true,
            message: '请选择',
            trigger: 'change'
          },
          PaymentAmount: {
            required: true,
            message: '请输入付款金额',
            trigger: 'blur'
          },
          PayComp: {
            required: true,
            message: '请选择付款公司',
            trigger: 'change'
          },
          PayAccount: {
            required: true,
            message: '请选择付款银行帐号',
            trigger: 'change'
          },
          ReceiveComp: {
            required: true,
            message: '请选择收款公司',
            trigger: 'change'
          },
          ReceiveAccount: {
            required: true,
            message: '请输入收款银行帐号',
            trigger: 'blur'
          },
          ReceiveBank: {
            required: true,
            message: '请输入收款方开户行',
            trigger: 'blur'
          },
          writtenAmount: {
            required: true,
            message: '请输入付款金额',
            trigger: 'blur'
          },
          FundUse: {
            required: true,
            message: '请输入款项用途',
            trigger: 'blur'
          },
          WriteOffMark: {
            required: true,
            message: '请选择',
            trigger: 'change'
          },
          WriteOffMark: {
            required: true,
            message: '请选择',
            trigger: 'change'
          }
        }
      }
    },
    created() {
      this.getlegalsubjectlist();
      this.getProList();
      this.getDepartList();
      this.getMemberList();
      this.GetAdDirectCaymList();
    },
    methods: {
      checkPermission,
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      // 获取部门列表
      getDepartList() {
        xz.getOrganstrsreach("", {
          strIsDisable: "1",
        }).then((res) => {
          // console.log('部门', res)
          if (res.status == "ok") {
            if (res.msg && res.msg.parent) {
              this.departList = res.msg.parent[0].children;
            } else {
              this.departList = [];
            }
          }
        });
      },
      // 获取人员列表
      getMemberList() {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        }
        xz.getauthUserInfoByorgancode(data).then((res) => {
          if (res.status == "ok") {
            this.customerList = res.msg;
          } else {
            this.customerList = [];
          }
        });
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      currentChange(val) {
        this.listQuery.pageModel.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageModel.page = 1;
        this.listQuery.pageModel.rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pageModel.page = 1;
        this.getList();
      },
      getList() {
        this.GetAdDirectCaymList();
      },
      GetAdDirectCaymList() {
        this.loading = true;
        xz.AdvanceFun(this.listQuery, 'GetAdDirectCaymList').then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      changeTab() {
        if (this.activeName == '0') {
          this.listQuery.PayResult = '';
          this.getList();
        } else {
          this.listQuery.PayResult = 2;
          this.getList();
        }
      },
      //新增付款
      addPayment() {
        this.payForm = {
          Id: '',
          DirectCaymType: '1', //直付类型1为内2为外
          PaymentAmount: '', //付款金额
          PayAccount: '', //付款账号
          PayComp: '', //付款公司
          PayCompOpenBank: '', //开户行
          ReceiveComp: '', //收款公司名
          ReceiveBank: '', //收款开户行
          ReceiveAccount: '', //收款账号
          CnapsCode: '', //联行号
          FundUse: '', //款项用途
          DescFees: '', //费用说明
          WriteOffMark: '0', //是否核销标记,1为要核销，0为不用核销
          SevrvceDeptName: '', //服务部门
          ProjectName: '', //
          PayResult: '', //付款结果1.打款成功2.打款失败，3待打款,4.打款中
          Summary: '', //付款说明
          FileName: '', //文件名
          FileUrl: '', //文件名URL
          PersonRespons: '', //责任人ID
          PersonResponsName: '', //责任人
          userId: Cookies.get("userid-b"),
        }
        this.showAddPaymnt = true;
      },
      changePayComp(val) {
        if (val) {
          xz.getCompfinanceSet(val, this.roletype).then(res => {
            if (res.status == 'ok') {
              if (!res.data.BankAccountJ) {
                this.BankAccount = []
              } else {
                res.data.BankAccountJ.forEach(element => {
                  if (element.IsDefault != undefined && element.IsDefault == '1') {
                    this.payForm.PayAccount = element.Account
                    this.payForm.PayCompOpenBank = element.OpeningBank;
                  }
                });
                this.BankAccount = res.data.BankAccountJ;
              }
            } else {
              this.BankAccount = [];
            }
          })
        }
      },
      inputChange(val, bank, item) {
        this.payForm[item] = bank;
      },
      changeReceiveComp(val) {
        if (val) {
          xz.getCompfinanceSet(val, this.roletype).then(res => {
            if (res.status == 'ok') {
              if (!res.data.BankAccountJ) {
                this.BankAccount2 = []
              } else {
                res.data.BankAccountJ.forEach(element => {
                  if (element.IsDefault != undefined && element.IsDefault == '1') {
                    this.payForm.ReceiveAccount = element.Account
                    this.payForm.ReceiveBank = element.OpeningBank;
                  }
                });
                this.BankAccount2 = res.data.BankAccountJ;
              }
            } else {
              this.BankAccount2 = [];
            }
          })
        }
      },
      departChange(val) {
        this.payForm.SevrvceDeptName = val[val.length - 1];
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      // 删除附件
      handleFileRemove() {
        this.payForm.FileUrl = '';
        this.payForm.FileName = '';
      },
      // 上传附件
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            // let data = {
            //   FileUrl: res,
            //   fileName: file.name
            // }
            // this.payForm.files.push(data)
            this.payForm.FileUrl = res;
            this.payForm.FileName = file.name;
          } else {
            this.payForm.FileUrl = '';
            this.payForm.FileName = '';
          }
        });
      },
      changePR(val) {
        this.payForm.PersonRespons = val.Userid;
        this.payForm.PersonResponsName = val.Username;
      },
      comfirmPay() {
        console.log(this.payForm)
        this.$refs["payForm"].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.AdvanceFun(this.payForm, 'AddUpdataAdDirectCaym').then(res => {
              if (res.status == 'ok') {
                xz.directPaymentSubmit(res.data, this.roletype).then(r => {
                  if (r.status == 'ok') {
                    this.$message.success('打款成功！');
                    this.isBtnLoading = false;
                    this.showAddPaymnt = false;
                  } else {
                    this.$message.error(r.msg);
                    this.isBtnLoading = false;
                    this.showAddPaymnt = false;
                  }
                })
              } else {
                this.$message.error(res.msg);
                this.isBtnLoading = false;
                this.showAddPaymnt = false;
              }
            })
          }
        })

      },
      changeCCD() {
        this.fullName = ''
      },
      querySearchAsync(event) {
        if (this.payForm.CnapsCode != undefined && this.payForm.CnapsCode) {
          this.marY = event.clientY - 320 < 0 ? 0 : event.clientY - 320;
          this.marX = event.clientX - 300 < 0 ? 0 : event.clientX - 300;
          xz.GetCnapsCodeByName(this.payForm.CnapsCode, 10000, 1).then(res => {
            if (res.status == 'ok') {
              this.recommendList = res.data.data;
              this.showAddressSelect = true;
            } else {
              this.recommendList = [];
              this.showAddressSelect = true;
            }
          })
        }
      },
      //选择联行号
      handleSelect(item) {
        this.payForm.CnapsCode = item.cnapsCode;
        this.payForm.ReceiveBank = item.fullName;
        this.showAddressSelect = false;
        this.fullName = item.fullName;
      },
      downReceipt(row) {
        this.loading = true;
        xz.getElectroniAdvDirectCaym(row.id, localStorage.loginRoletype).then(res => {
          if (res.status == 'ok') {
            let path = 'https://emp.joball.net/cloudimg/' + res.data;
            const aTag = document.createElement('a')
            aTag.href = path;
            aTag.download = row.busNum + ".pdf";
            aTag.click();
            this.loading = false;
          } else {
            this.$message.error(res.msg)
            this.loading = false;
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .payInput {
    height: 32px;
    margin-top: 4px;
  }

  .addressSelect {
    width: 450px !important;
    position: absolute;
    top: 40px;
    background: #fff;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    max-height: 200px;
    width: 300px;
    overflow: auto;
    padding: 10px 0;
    z-index: 2000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }

  .addressSelectItem {
    padding: 0 0 0 10px;
  }
</style>
<style>
  .page_directPayment .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_directPayment .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_directPayment .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_directPayment .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_directPayment .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_directPayment .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_directPayment .payInput .el-input-group__append,
  .page_directPayment .payInput .el-input-group__prepend {
    padding: 0 0 0 5px;
    background: #fff;
    border-right: none !important;
  }

  .page_directPayment .payInput .el-input__inner {
    border-left-color: #fff;
    padding-left: 3px;
  }
</style>